export const BASE_APP_URL = process.env.REACT_APP_BASE_URL
export const BASE_PORTAL_URL = `${BASE_APP_URL}api/portal/`
export const BASE_TOKEN_URL = `${BASE_APP_URL}api/user`
export const BASE_CUSTOMER_PROFILE_URL = `${BASE_APP_URL}api/portal/customer-profile/`
export const BASE_CUSTOMER_URL = `${BASE_APP_URL}api/portal/customer/`
